import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { makeTxtOverFLow } from '../utils/format'

function CountCard({ imgPath, title, count, handleOnClick }) {
    return (
        <>
            <Stack direction={'row'}>
                <Button variant="standard" onClick={handleOnClick} sx={{
                    boxShadow: 7, border: 0.2, borderRadius: 8, borderColor: "rgba(0,0,0,0.3)", width: 290, height: 50,
                    padding: 2, fontSize: 11, marginTop: 1, marginRight: 3, marginleft: 10
                }}  >
                    <Stack>
                        <Typography sx={{ fontSize: 15, fontWeight: 500, color: "rgba(53, 65, 236, 1)" }} >{makeTxtOverFLow(count.toString(), 12)}</Typography>
                        <Typography sx={{ fontSize: 13, fontWeight: 400, color: "rgba(0,0,0,0.8)" }}>{title}</Typography>
                    </Stack>
                    <img src={imgPath} alt={imgPath} style={{ height: 30, marginLeft: 30, marginRight: 3, marginTop: 1 }} /></Button>
            </Stack>

        </>
    )
}
export default CountCard